/** Cliente HTTP para Visor WhatsApp Bridge (modo híbrido Windows, localhost). */

export const WHATSAPP_BRIDGE_DEFAULT_PORT = 9781;
export const WHATSAPP_BRIDGE_BASE_URL = `http://127.0.0.1:${WHATSAPP_BRIDGE_DEFAULT_PORT}`;

/**
 * @returns {Promise<{ ok: boolean, window_running?: boolean, edge_available?: boolean, version?: string } | null>}
 */
export async function probeWhatsAppBridge(timeoutMs = 2000) {
  if (typeof window === "undefined") return null;
  try {
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), timeoutMs);
    const res = await fetch(`${WHATSAPP_BRIDGE_BASE_URL}/health`, {
      signal: controller.signal,
      cache: "no-store",
    });
    window.clearTimeout(timer);
    if (!res.ok) return null;
    const data = await res.json();
    return data?.ok ? data : null;
  } catch {
    return null;
  }
}

/**
 * @returns {Promise<{ ok: boolean, action?: string, error?: string, message?: string } | null>}
 */
export async function openWhatsAppBridgeWindow() {
  if (typeof window === "undefined") return null;
  try {
    const res = await fetch(`${WHATSAPP_BRIDGE_BASE_URL}/open`, { method: "POST" });
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}

/**
 * @returns {Promise<{ ok: boolean, action?: string } | null>}
 */
export async function focusWhatsAppBridgeWindow() {
  if (typeof window === "undefined") return null;
  try {
    const res = await fetch(`${WHATSAPP_BRIDGE_BASE_URL}/focus`, { method: "POST" });
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}
